import { useSignedNotifications } from '@/client/hooks/use-signed-notifications';
import { ApiInstance, NotificationCategory, NotificationStatus } from '@/libs/sdk/api';
import { useMemo } from 'react';

export const useNotificationStatus = (api: ApiInstance) => {
  const transactionNotification = useSignedNotifications(api, {
    page: 1,
    pageSize: 1,
    status: NotificationStatus.unread,
    category: NotificationCategory.transaction,
  });
  const mentionNotification = useSignedNotifications(api, {
    page: 1,
    pageSize: 1,
    status: NotificationStatus.unread,
    category: NotificationCategory.mention,
  });
  const transactionList = useMemo(
    () => transactionNotification.data?.pages.flatMap(item => item.notifications) || [],
    [transactionNotification.data?.pages]
  );
  const mentionList = useMemo(
    () => mentionNotification.data?.pages.flatMap(item => item.notifications) || [],
    [mentionNotification.data?.pages]
  );
  const hasNewTransaction = useMemo(
    () => transactionList.length > 0 && transactionList.every(item => item.status == NotificationStatus.unread),
    [transactionList]
  );
  const hasNewMention = useMemo(
    () => mentionList.length > 0 && mentionList.every(item => item.status == NotificationStatus.unread),
    [mentionList]
  );
  const hasNewNotification = useMemo(() => hasNewTransaction || hasNewMention, [hasNewMention, hasNewTransaction]);
  const isNotificationLoading = useMemo(
    () => transactionNotification.isLoading || mentionNotification.isLoading,
    [transactionNotification.isLoading, mentionNotification.isLoading]
  );
  return {
    isNotificationLoading,
    transactionNotification,
    mentionNotification,
    transactionList,
    mentionList,
    hasNewTransaction,
    hasNewMention,
    hasNewNotification,
  };
};
